import { render } from "./DProducts.vue?vue&type=template&id=3db89ff9"
import script from "./DProducts.vue?vue&type=script&lang=js"
export * from "./DProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__